var React = require('react');

function ChangelogSmallLoading (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"68","height":"16","rx":"8","fill":"white","fillOpacity":"0.1"}));
}

ChangelogSmallLoading.defaultProps = {"width":"68","height":"16","viewBox":"0 0 68 16","fill":"none"};

module.exports = ChangelogSmallLoading;

ChangelogSmallLoading.default = ChangelogSmallLoading;
